<template>
  <div>
    <BeerInput
      v-model="currentPageNo"
      :bs="{ mx: 'x', width: 40 }"
      type="number"
      placeholder="页码"
      :input-bs="{
        textAlign: 'center',
        px: 0
      }"
      @keyup="onKeyup"
      @blur="confirm"
    />
    <slot name="right" />
    <BeerButton
      v-if="showJump"
      :bs="{ mr: 0 }"
      size="nm"
      variant="text"
      @click="confirm"
    >
      跳转
    </BeerButton>
  </div>
</template>

<script lang="ts">
  import {
    defineComponent, ref, watch, PropType,
  } from 'vue'
  import BeerButton from '@xhs/yam-beer/cmp/common/Button/Button.vue'
  import BeerInput from '@xhs/yam-beer/cmp/dataEntry/Input/Input.vue'

  export default defineComponent({
    name: 'PagerInput',
    components: {
      BeerButton,
      BeerInput,
    },
    props: {
      modelValue: {
        type: Number as PropType<number>,
      },
      maxValue: Number,
      showJump: {
        type: Boolean,
        default: false,
      },
    },
    emits: ['update:modelValue'],
    setup(props, { emit }) {
      const currentPageNo = ref<number|null>(props.modelValue || null)
      watch(() => props.modelValue, v => {
        currentPageNo.value = v || null
      })
      const confirm = () => {
        let newPageNo = Math.floor(Number(currentPageNo.value))

        if (newPageNo < 1) {
          newPageNo = 1
        }
        if (props.maxValue && newPageNo > props.maxValue) {
          newPageNo = props.maxValue
        }

        if (newPageNo === props.modelValue) {
          currentPageNo.value = newPageNo
          return
        }
        currentPageNo.value = null
        emit('update:modelValue', newPageNo)
      }

      return {
        confirm,
        currentPageNo,
        onKeyup(e: KeyboardEvent) {
          if (e.keyCode === 13) {
            confirm()
          }
        },
      }
    },
  })
</script>
